export default __webpack_public_path__ + "static/media/531.b499f135.png";